import { render, staticRenderFns } from "./currencyCoupon.vue?vue&type=template&id=1105d589&scoped=true&"
import script from "./currencyCoupon.vue?vue&type=script&lang=js&"
export * from "./currencyCoupon.vue?vue&type=script&lang=js&"
import style0 from "./currencyCoupon.vue?vue&type=style&index=0&id=1105d589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1105d589",
  null
  
)

export default component.exports